// Figma 6398:31611: on desktop each redesigned screen is a bordered warm card inset on a white page; below lg it stays full-bleed.
// Every screen root carries it, so it also scopes the redesign's Inter-only type (onboarding-type).
export const onboardingFramePage = "onboarding-type lg:bg-surface lg:py-800"
// The camera screens keep their dark fill inside the same card.
export const onboardingFrameShape = "lg:vv-h-framed lg:flex-none lg:rounded-onboarding-card lg:border lg:border-line-sand lg:overflow-hidden"
export const onboardingFrameCard = `${onboardingFrameShape} lg:bg-surface-flow`
